export default "__VITE_ASSET__2ac6bafb__"